import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { Florder } from 'app/core/interfaces/florder.interface';
import { CalendarCustomer, CalendarDay, CalendarFlorderInfo } from 'app/core/store/calendar/common/calendar.interface';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { logger } from 'app/core/util/logger';

@Component({
  selector: 'app-calendar-florder-info-list',
  templateUrl: './calendar-florder-info-list.component.html',
  styleUrls: ['./calendar-florder-info-list.component.scss'],
})
export class CalendarFlorderInfoListComponent implements OnInit {
  SLICE_NUMBER: number = 3;

  showTooltip = null;
  private showHideTooltip$ = new Subject<{ florder: Florder; boundingBox: DOMRectInit }>();

  @Input() day: CalendarDay;
  @Input() customers: CalendarCustomer[];
  @Input() tooltipRef: TemplateRef<any>;
  @Output() openFlorder = new EventEmitter<CalendarFlorderInfo>();

  tooltipStyle: any;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.showHideTooltip$.pipe(debounceTime(1000)).subscribe(({ florder, boundingBox }) => {
      this.showTooltip = florder;
      if (boundingBox) {
        let { x, y } = boundingBox;
        if (x > 1005) {
          x = x - 755;
        } else {
          x = x + 160;
        }
        const scale = '0.7';
        this.tooltipStyle = { left: x + 'px', top: y + 'px', transform: `scale(${scale}, ${scale})` };
      }
    });
  }

  mouseenter(florder, event) {
    this.showHideTooltip$.next({ florder, boundingBox: event.target.getBoundingClientRect() });
  }

  mouseleave(florder) {
    this.showHideTooltip$.next({ florder: null, boundingBox: null });
  }

  tooltipBoundingBoxChange(boundingBox: DOMRectInit) {
    if (boundingBox.y + boundingBox.height > window.innerHeight) {
      this.tooltipStyle = {
        ...this.tooltipStyle,
        top: `${window.innerHeight - boundingBox.height}px`,
      };
    }
    if (boundingBox.y < 0) {
      this.tooltipStyle = {
        ...this.tooltipStyle,
        top: 0,
      };
    }
    this.cd.markForCheck();
  }

  tooltipBoundingBoxChangeBnd = this.tooltipBoundingBoxChange.bind(this);

  findBackgroundColor(customerId: string) {
    const customer = this.customers.find(customer => customer.id === customerId);
    if (!customer) {
      logger.error(`Customer ${customerId} not found in legend !!`);
    }
    return (customer && customer.color) || '#0067b1';
  }

  findColor(customerId: string) {
    const customer = this.customers.find(customer => customer.id === customerId);
    if (!customer) {
      logger.error(`Customer ${customerId} not found in legend !!`);
    }
    if (customer) {
      if (customer.colorType === 'dark') {
        return 'white';
      } else {
        return 'black';
      }
    } else {
      return 'white';
    }
  }
}
